import React from 'react'
import './Controls.css'

const ControlInput = (props) => (
  <div className='control'>
    <div className='control__label'>{props.label}</div>
    <input
      className={props.error ? 'control__input control__input--error' : 'control__input'}
      type={props.type}
      value={props.value}
      placeholder={props.placeholder}
      readOnly={props.readOnly}
      required={props.required}
      onChange={props.onChange}
    />
  </div>
)

const ControlSelect = (props) => (
  <div className='control'>
    <div className='control__label'>{props.label}</div>
    <div className='control__select__container'>
      <select
        className={props.error ? 'control__select control__select--error' : 'control__select'}
        value={props.value}
        onChange={props.onChange}
      >
        <option value='' disabled>{props.placeholder}</option>
        {props.options.map((opt) => <option value={opt.value} key={opt.value}>{opt.label}</option>)}
      </select>
    </div>
  </div>
)

export { ControlInput, ControlSelect }
